import { mapActions } from 'vuex';
import { getAppData } from '@/utils';

let triggeredId = '';
export const connect = {
	computed: {
		connectLoading() {
			return this.$store.getters.isLoading(['connect', 'disconnect']);
		},
	},
	mounted() {
		window.addEventListener('message', this.listenMessage);
		if (window.location.hash && '#connect' === window.location.hash) {
			const hashless = window.location.href.split('#')[0];
			// Remove hash and open the connect window.
			window.location.hash = '';
			window.history.replaceState(null, null, hashless);
			this.handle();
		}
	},
	beforeDestroy() {
		window.removeEventListener('message', this.listenMessage);
	},
	methods: {
		...mapActions(['saveApiKey']),
		...mapActions({
			disconnectApiKey: 'disconnect',
		}),
		success(disconnect = false) {
			this.$emit('onSuccess', disconnect);
			if (this.refreshAfter) {
				// Put the loader back in place.
				this.$store.commit('loading', disconnect ? 'disconnect' : 'connect');
				window.location.reload();
			}
		},
		async listenMessage(evt) {
			// Only listen in if this is the button that fired the window!
			if (!triggeredId || triggeredId !== this._uid) {
				return;
			}

			const { origin, data } = evt;
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return;
			}

			if (!data || 'string' !== typeof data || 0 === data.indexOf('{')) {
				// eslint-disable-next-line no-console
				console.error(
					'Messages from "' + this.$urls.app() + '" must contain an api key string. Data given: ',
					'\n\n',
					data
				);
				return;
			}

			await this.saveApiKey(data);

			this.success();
		},
		async handle() {
			triggeredId = this._uid;
			if (this.disconnect) {
				await this.disconnectApiKey();

				return this.success(true);
			}

			try {
				var url = this.$urls.app(
					'wordpress/connect/?site=' +
						encodeURIComponent(getAppData('blogname')) +
						'&v=' +
						encodeURIComponent(getAppData('pluginVersion'))
				);
				var w = window.open(url, '_blank', 'location=no,width=500,height=730,scrollbars=0');
				w.focus();
			} catch (e) {
				alert('Your browser blocked the authorization window from opening. Please check your popup settings.');
			}
		},
	},
};
